var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-entity",
    [
      _c(
        "a-entity",
        { attrs: { "position-from-sky": _vm.position } },
        [
          _c("a-image", {
            staticClass: "clickable close_on_active",
            attrs: {
              width: _vm.infospot.width,
              height: _vm.infospot.height,
              src: _vm.infospot.icon,
              "hover-effect-scale": "scale: 1.25",
              "play-sound": "audio: #audio-bop; events: click",
              "toggle-modal": "#modal-" + _vm.infospot.id,
              tooltip: _vm.infospot.tooltip,
              showline: _vm.infospot.xyz,
            },
            on: { click: _vm.onClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-entity",
        {
          class: { intro_panel: _vm.infospot.initially_opened },
          attrs: {
            id: "modal-" + _vm.infospot.id,
            "advanced-visible": "false",
            modal: _vm.modalAttributeString,
          },
        },
        [_c("info-spot-content", { attrs: { infospot: _vm.infospot } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }